import { render, staticRenderFns } from "./OrganizationFilters.vue?vue&type=template&id=24da3433&"
import script from "./OrganizationFilters.vue?vue&type=script&lang=js&"
export * from "./OrganizationFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports